import React from "react";
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import "./Home.scss";
import { github, linkedIn } from "../../Data/Data";

const Home = () => {
    return (
        <section className="home" id="home">
            <div className="home__details">
                <div className="home__details-info">
                    <h6>WELCOME TO MY WORLD</h6>
                    <h1>
                        Hi, I'm <span>Shamsul H. Forhad</span>
                    </h1>
                    <h2>a Fullstack Developer</h2>
                    <p>
                        I use Nodejs and Reactjs to build websites. I am capable
                        to make asynchronous and scalable backend with Nodejs.
                        And also make fully responsive and reusable frontend
                        with Reactjs.
                    </p>
                </div>
                <div className="home__details--links">
                    <div className="home__details--links-div">
                        <h5>FIND WITH ME</h5>
                        <div className="home__details--links-div-icons">
                            <a href={linkedIn} className="find">
                                <AiFillLinkedin />
                            </a>
                            <a href={github} className="find">
                                <AiFillGithub />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="home__img">
                <div className="home__img-bg">
                    <img
                        src="./images/forhad.png"
                        alt="forhad"
                        className="bgImg"
                    />
                </div>
            </div>
        </section>
    );
};

export default Home;
